/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section4_P2Inputs */

const en_terms_section4_p2 = /** @type {(inputs: Terms_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are solely responsible for verifying the output of any tool before using it in a production environment. PureJSON shall not be liable for any damages arising from the use of the service.`)
};

const ko_terms_section4_p2 = /** @type {(inputs: Terms_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로덕션 환경에서 사용하기 전에 도구의 출력을 직접 확인할 책임은 사용자에게 있습니다. PureJSON은 서비스 사용으로 인해 발생하는 어떠한 손해에 대해서도 책임을 지지 않습니다.`)
};

const ja_terms_section4_p2 = /** @type {(inputs: Terms_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本番環境で使用する前にツールの出力を確認する責任はユーザーにあります。PureJSONはサービスの使用から生じるいかなる損害についても責任を負いません。`)
};

/**
* | output |
* | --- |
* | "You are solely responsible for verifying the output of any tool before using it in a production environment. PureJSON shall not be liable for any damages ari..." |
*
* @param {Terms_Section4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section4_p2 = /** @type {((inputs?: Terms_Section4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section4_p2(inputs)
	if (locale === "ko") return ko_terms_section4_p2(inputs)
	return ja_terms_section4_p2(inputs)
});